import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchClinics = async () => {
  const token = localStorage.getItem("token");

  const response = await axios.get(`${__API_URL__}/api/appointments/all_practitioner_clinics`, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return response.data;
};

const useGetClinics = ({ enabled = true } = {}) => {
  return useQuery({
    queryKey: ["clinics"],
    queryFn: fetchClinics,
    enabled,
  });
};

export default useGetClinics;
